<template>
  <div class="detail">
    <div class="top">
      <div class="title">{{ description.actionType }}</div>
      <div class="time">{{ description.doneTime }}</div>
      <div class="title">{{ description.userName }}</div>
    </div>
    <div class="line" v-if="description.orgName"></div>
    <div class="bottom" v-if="description.orgName">
      {{ description && description.orgName }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showIt: true,
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.detail {
  width: 550px;
  min-height: 93px;
  background: rgba(247, 249, 255, 1);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  img {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .top {
    width: 502px;
    height: 37px;
    margin: 0 auto;
    line-height: 37px;
    margin-top: 14px;
    display: flex;
    justify-content: space-between;
    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 26px;
      font-weight: bold;
    }
    .time {
      color: rgba(51, 51, 51, 1);
      font-size: 26px;
    }
  }
  .line {
    width: 100%;
    margin-top: 13px;
    border-top: 1px dashed rgba(226, 228, 234, 1);
  }
  .bottom {
    margin: 24px 32px 24px 24px;
    color: rgba(0, 0, 0, 1);
    font-size: 26px;
    line-height: 40px;
  }
}
</style>
